export default __webpack_public_path__ + "static/media/second.a29f4db7.svg";